/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  FeatureSectionService,
  IFeatureSectionMethods,
  StaticPageContentService,
  IStaticPageContentMethods,
  ISectionOptionTypeMethods,
  SectionOptionTypePageService,
  ISectionOptionMethods,
  SectionOptionService,
  IFeatureMethods,
  FeatureService,
  IAttributeMethods,
  AttributeService,
  ValueService,
  IValueMethods,
  ISectionMethods,
  SectionService,
  IGetCostumeTypePreviewMethods,
  GetCostumeTypePreviewService,
  GetTemplateFeaturesService,
  IGetTemplateFeaturesMethods,
  ImportSectionAssetService,
  IImportSectionAssetMethods,
  ImportGlobalAssetService,
  IImportGlobalAssetMethods,
} from "./components";

export type SectionOptionTypeAgent = IHeaderMethods &
  IFeatureSectionMethods &
  IFooterMethods &
  ISectionOptionTypeMethods &
  IFeatureMethods &
  IValueMethods &
  ISectionMethods &
  ISectionOptionMethods &
  IAttributeMethods &
  IStaticPageContentMethods &
  IGetTemplateFeaturesMethods &
  IImportSectionAssetMethods &
  IImportGlobalAssetMethods &
  IGetCostumeTypePreviewMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new FeatureSectionService(),
    new ImportSectionAssetService(),
    new FooterService(),
    new AttributeService(),
    new ImportGlobalAssetService(),
    new SectionOptionService(),
    new SectionOptionTypePageService(),
    new FeatureService(),
    new GetTemplateFeaturesService(),
    new ValueService(),
    new StaticPageContentService(),
    new SectionService(),
    new GetCostumeTypePreviewService(),
  ];
};

export const getAgent = () => {
  return createAgent<SectionOptionTypeAgent>({
    plugins: getPlugins(),
  });
};
